import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createTemplate,
  deleteTemplate,
  fetchTemplate,
  fetchTemplates,
  renderTemplate,
  updateTemplate,
} from "../api/promptTemplates";

export function useTemplates() {
  return useQuery({
    queryKey: ["prompt-templates"],
    queryFn: fetchTemplates,
  });
}

export function useTemplate(id: string) {
  return useQuery({
    queryKey: ["prompt-template", id],
    queryFn: () => fetchTemplate(id),
    enabled: !!id,
  });
}

export function useCreateTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: Record<string, unknown>) => createTemplate(body),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["prompt-templates"] });
    },
  });
}

export function useUpdateTemplate(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: Record<string, unknown>) => updateTemplate(id, body),
    onSuccess: (data) => {
      qc.setQueryData(["prompt-template", id], data);
      void qc.invalidateQueries({ queryKey: ["prompt-templates"] });
    },
  });
}

export function useDeleteTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deleteTemplate(id),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["prompt-templates"] });
    },
  });
}

export function useRenderTemplate(id: string) {
  return useMutation({
    mutationFn: (values: Record<string, string>) => renderTemplate(id, values),
  });
}
